<template>
  <div>
    <a href="#/search" class="back-to-home">
      <i class="fas fa-angle-double-left"></i>
      Back to Home Page
    </a>

    <service-header></service-header> 

    <div :class="['d-flex select-box', {'filter-open':isFilterOpen}]" id="serviceContent">
      <sidebar ref="sidebar" 
        :class="['filter-sidebar', {
          'side-sticky':!isMobile,
          'custom-fl':Object.keys(leg1Selected).length,
          'custom-fl2':booking.filters.departure.isReturning && hasSelectedFlight && false,
          'fl-only':other.widgetTab === 'flight',
          'solo-flight':!booking.filters.departure.isReturning
        }]"
      />

      <div class="filter-wrapper">
        <button @click="isFilterOpen = !isFilterOpen" class="btn-sm">
          <i class="fa fa-times-circle" v-if="isFilterOpen"></i>
          <i class="fas fa-filter" v-else></i>
          Sort and Filter
        </button>
      </div>

      <div class="service-box">
        <services ref="services" />
      </div>

      <div class="apply-filter-btn">
        <button class="op-btn btn-md btn-block btn-secondary" @click="isFilterOpen = !isFilterOpen">
          <span>Cancel</span>
        </button>
        <button class="op-btn btn-md btn-block btn-success" @click="isFilterOpen = !isFilterOpen">
          <span>Apply Filter</span>
        </button>
      </div>
    </div>

    <confirm-rt-modal></confirm-rt-modal>
  </div>
</template>

<script>
// /* global CONFIG */
import moment from 'moment-timezone'
import ServiceHeader from './ServiceHeader'
import Sidebar from './Sidebar'
import Services from './Services'
import ConfirmRtModal from './confirm-rt-modal'

export default {
  name: 'service-selection',
  components: { ServiceHeader, Sidebar, Services, ConfirmRtModal },
  data () {
    return {
      isFilterOpen: false,
      isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
      nearByAirport: {
        pickup: '',
        dropoff: ''
      },
      moment: moment
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    locations () { return this.booking.locations },
    locDynamic () {
      if (this.other.widgetTab === 'd2d') {
        return {
          pickup: this.locations.pickupAirport,
          dropoff: this.locations.dropoffAirport
        }
      }
      return this.locations.flight
    },
    airlines () { return this.booking.airlines },
    disableNearby () { return this.airlines.leg1.loading.length > 0 || (this.booking.filters.departure.isReturning && this.airlines.leg2.loading.length > 0) },
    leg1Selected () { return this.booking.selected.leg1 },
    leg2Selected () { return this.booking.selected.leg2 },
    hideGround () { return this.booking.hideGround },
    hasSelectedFlight () { return Object.keys(this.leg1Selected).length && Object.keys(this.leg2Selected).length },
    other () { return this.$store.state.other },
    currency () { return this.other.currency }
  },
  methods: {
    back () {
      this.$router.push('search')
    }
  },
  watch: {
    isFilterOpen () {
      if (!this.isMobile) return
      if (this.isFilterOpen) {
        document.body.classList.add('filter-open')
      } else {
        document.body.classList.remove('filter-open')
      }
    }
  },
  mounted () {
    if (!this.booking.filters.departure.date) {
      this.$root.$router.push('search')
      return
    }

    let pIndex = this.booking.nearByAirports.pickup.findIndex(x => x.airport.code === this.booking.locations.pickupAirport.code)
    if (pIndex > -1) this.nearByAirport.pickup = pIndex
    let dIndex = this.booking.nearByAirports.dropoff.findIndex(x => x.airport.code === this.booking.locations.dropoffAirport.code)
    if (dIndex > -1) this.nearByAirport.dropoff = dIndex
  }
}
</script>

<style lang="scss" scoped>
$screen-medium: 64em;
$screen-small: 40em;

.back-to-home{
  margin-bottom: 10px;
  display: inline-block;
  letter-spacing: .6px;

  i{
    margin-right: 5px;
    vertical-align: -1px;
  }
}


.select-box{
  margin-top: 15px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 3px -1px rgba(0, 0, 0, .1);
}
.side-sticky{
  position: -webkit-sticky;
  position: sticky;
  top: 10px;
  width: 33.3%;
  max-width: 350px;
  height: calc(100vh - 20px);
  overflow: auto;
  
  &.solo-flight{
    top: 10px;
    height: calc(100vh - 20px);
  }
  &.fl-only{
    // top: 230px !important;
    // height: calc(100vh - 235px);
    top: 10px;
    height: calc(100vh - 20px);

    &.solo-flight{
      // top: 158px !important;
      // height: calc(100vh - 165px)!important;
    }
  }
  &.custom-fl{
    // top: 285px;
    // height: calc(100vh - 290px);

    &.fl-only{
      // top: 230px;
      // height: calc(100vh - 235px);
    }
    &.solo-flight{
      // top: 212px;
      // height: calc(100vh - 217px);
    }
  }
  &.custom-fl2{
    // top: 375px!important;
    // height: calc(100vh - 380px);

    &.fl-only{
      // top: 323px!important;
      // height: calc(100vh - 326px);
    }
  }

  @media only screen and (max-width: $screen-small) {
    width: 0;
    max-width: 100%;
    top: 0!important;
  }
}

@media only screen and (max-width: $screen-small) {
  .filter-sidebar {
    display: none;
  }
}

.filter-wrapper {
  display: none;

  @media only screen and (max-width: $screen-small) {
    display: block;
    margin-bottom: 15px;

    button {
      border: 2px solid #CCD0E2;
      padding: 10px 20px;
      color: #5E6E7F;
      border-radius: 4px;
      letter-spacing: .6px;
      font-size: 18px;

      i{
        margin-right: 5px;
        font-size: 16px;
      }
    }

  }
}

.apply-filter-btn {
  display: none;
}

.filter-open {
  .filter-wrapper {
    display: none;
  }

  .apply-filter-btn {
    width: 100%;
    display: flex;
    gap: 15px;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 1.3rem 1rem;
    background-color: #fff;
    z-index: 2;
    border-top: 1px solid #dedede;
  }
}

.service-box{
  width: 100%;
  max-width: calc(100% - 350px);
}

@media only screen and (max-width: $screen-small) {
  .hide-in-mob{
    display: none;
  }

  .select-box{
    flex-direction: column;
  }
  .filter-open {
    .filter-sidebar {
      display: block;
      width: 100%;
      height: calc(100% - 81px);
      position: fixed;
      top: 0;
      z-index: 2;
      left: 0;
      background: #fff;
      overflow-y: auto !important;
    }
  }

  .service-box{
    max-width: 100%;
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .30s ease backwards; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?57479f3e